import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';

class SingleFilterList extends React.Component {
  static defaultProps = {
    getValue: facet => facet.value,
    getName: facet => facet.value,
    className: '',
  };

  selectFilter = (facet) => {
    this.props.onChange(this.props.getValue(facet));
  };

  isSelected = facet => this.props.selected === this.props.getValue(facet);

  renderCount = facet => (
    <span className="facet__option__count">
        ({facet.count})
    </span>
  );

  renderLabel = facet => (
    <span className="facet__link__text">
      {this.props.getName(facet)}
    </span>
  );

  renderLink = (facet) => {
    const callback = () => this.selectFilter(facet);

    return (
      <a
        href="#"
        rel="nofollow"
        onClick={callback}
        className="facet__link"
      >
        {this.renderLabel(facet)}
        {this.renderCount(facet)}
      </a>
    );
  };

  renderFilter = (facet) => {
    const id = `${this.props.name}-${this.props.getValue(facet)}`.replace(/ /g, '_');
    const activeClass = { 'facet__option--active': this.isSelected(facet) };

    return (
      <li
        key={id}
        data-filter={id}
        className={classNames('facet__option', activeClass)}
      >
        {this.renderLink(facet)}
      </li>
    );
  };

  render() {
    if (!this.props.facets) { return false; }

    return (
      <ul className="facet__options">
        {this.props.facets.map(facet => this.renderFilter(facet))}
      </ul>
    );
  }
}

SingleFilterList.PropTypes = {
  name: PropTypes.string.isRequired,
  facets: PropTypes.array.isRequired, // array of {value:, count:}
  selected: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  getValue: PropTypes.func,
  getName: PropTypes.func,
  className: PropTypes.string,
};

export default SingleFilterList;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/single_filter_list.jsx